/* eslint-disable no-nested-ternary */
import InputComponent from "components/InputG";
import { useState, useEffect } from "react";
import { FaSave } from "react-icons/fa";
import {
  MdContactPhone,
  MdEventNote,
  MdPhoneInTalk,
  MdFilterList,
} from "react-icons/md";
import { useEditarCampanha } from "services/api/Common_Campanhas/put-editar-campanha";
import { toast } from "react-toastify";
import SwitchComponent from "components/SwitchG";
import { useGetDetalheCampanha } from "services/api/Common_Campanhas/get-detalhe-campanha";
import { useHistory, useParams } from "react-router-dom";
import FilterDrawer from "../FilterDrawer";
import * as S from "./styles";
import CorretoresSelector from "./components/CorretoresSelector";

interface Props {
  cargos: {
    isCorretor: boolean;
    isGerenteVendas: boolean;
    isSuperintendente: boolean;
  };
}

interface Indicadores {
  totalContatos: number;
  contatosFiltrados: number;
  contatosRestantes: number;
  mediaLigacoesDiarias: number;
  diasCorridos: number;
}

interface CampanhaData {
  nome: string;
  descricao: string;
  ativo: boolean;
  indicadores?: Indicadores;
  idsCorretoresSistemaOrigem: string[];
  idEquipe: string;
  nomeEquipe: string;
}

const DetailCampanha: React.FC<Props> = ({ cargos }) => {
  const params: any = useParams();
  // const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [corretoresSelecionados, setCorretoresSelecionados] = useState<
    string[]
  >([]);
  const [campanhaData, setCampanhaData] = useState<CampanhaData>({
    nome: "",
    descricao: "",
    ativo: false,
    indicadores: {
      totalContatos: 0,
      contatosFiltrados: 0,
      contatosRestantes: 0,
      mediaLigacoesDiarias: 0,
      diasCorridos: 0,
    },
    idEquipe: "",
    nomeEquipe: "",
    idsCorretoresSistemaOrigem: [],
  });

  const history = useHistory();

  const { data: dataDetalheCampanha, isFetching: isFetchingDetalheCampanha } =
    useGetDetalheCampanha({
      queryKey: "detalhe_campanha",
      idCampanha: params.id,
    });

  const { mutate: editarCampanha, isLoading: isPendingEditarCampanha } =
    useEditarCampanha();

  useEffect(() => {
    if (dataDetalheCampanha) {
      setCampanhaData(dataDetalheCampanha);
    }
  }, [dataDetalheCampanha]);

  const handleSalvarCampanha = () => {
    editarCampanha(
      {
        idCampanha: params.id,
        ativo: campanhaData.ativo,
        idsCorretorSistemaOrigem: corretoresSelecionados,
      },
      {
        onSuccess: () => {
          toast.success("Campanha salva com sucesso!");
          history.push("/campanhas-criadas");
        },
        onError: (error: any) => {
          const notifications = error?.response?.data?.notifications;
          const errorMessages = Array.isArray(notifications)
            ? notifications.map((item: any) => `\n${item?.message}\n`).join("")
            : "Erro ao salvar campanha. Tente novamente.";
          toast.error(errorMessages, { autoClose: 10000 });
        },
      }
    );
  };
  return (
    <S.Container>
      <S.Header>
        <S.Title>CONFIGURAÇÕES DA CAMPANHA</S.Title>
        <S.Line />
      </S.Header>
      <S.Content>
        <S.ContainerLeft style={{ width: "60%" }}>
          <S.FlexContainer>
            <S.ColContainer style={{ width: "100%" }}>
              <InputComponent
                label="Nome da campanha"
                onChange={() => {}}
                value={
                  isFetchingDetalheCampanha
                    ? "Carregando..."
                    : campanhaData.nome
                }
                placeholder="Digite o nome da campanha"
                disabled={
                  cargos.isSuperintendente ||
                  cargos.isGerenteVendas ||
                  isFetchingDetalheCampanha
                }
              />

              <InputComponent
                label="Descrição da campanha"
                onChange={() => {}}
                value={
                  isFetchingDetalheCampanha
                    ? "Carregando dados da campanha..."
                    : campanhaData.descricao
                }
                placeholder="Digite a descrição da campanha"
                multiline
                type="text"
                rows={13}
                disabled={
                  cargos.isSuperintendente ||
                  cargos.isGerenteVendas ||
                  isFetchingDetalheCampanha
                }
              />
            </S.ColContainer>
            <S.ColContainer style={{ width: "100%" }}>
              <div style={{ marginBottom: "4px" }}>
                <S.Title3 style={{ marginBottom: "16px" }}>Status</S.Title3>
                <SwitchComponent
                  label="Campanha ativa"
                  onChange={() => {
                    campanhaData.ativo = !campanhaData.ativo;
                    setCampanhaData({ ...campanhaData });
                  }}
                  checked={
                    isFetchingDetalheCampanha ? false : campanhaData.ativo
                  }
                  value={campanhaData.ativo ? "true" : "false"}
                  disabled={
                    cargos.isSuperintendente || isFetchingDetalheCampanha
                  }
                />
              </div>
              <div>
                <S.TitleData>Minha base de dados</S.TitleData>
                <S.ContainerData>
                  <S.DataHeader>
                    <S.DataLeft>
                      <S.BigNumber>
                        {isFetchingDetalheCampanha
                          ? "..."
                          : campanhaData?.indicadores?.totalContatos.toString() ||
                            "X.XXX"}
                      </S.BigNumber>
                      <S.DataLabel>contatos filtrados</S.DataLabel>
                    </S.DataLeft>
                    {/* {false && (
                      <S.FilterButton
                        onClick={() => setIsFilterDrawerOpen(true)}
                      >
                        <MdFilterList />
                        <span>Filtrar contatos</span>
                        <S.NotificationBadge>4</S.NotificationBadge>
                      </S.FilterButton>
                    )} */}
                  </S.DataHeader>

                  <S.DataInfo>
                    <S.InfoItem>
                      <MdContactPhone size={50} />
                      <S.InfoText>
                        <S.InfoNumber>
                          {isFetchingDetalheCampanha
                            ? "..."
                            : campanhaData?.indicadores?.contatosRestantes.toString() ===
                              "0"
                            ? "X.XXX"
                            : campanhaData?.indicadores?.contatosRestantes.toString() ||
                              "X.XXX"}
                        </S.InfoNumber>{" "}
                        contatos restantes na campanha
                      </S.InfoText>
                    </S.InfoItem>

                    <S.InfoItem>
                      <MdPhoneInTalk size={24} />
                      <S.InfoText>
                        <S.InfoNumber>
                          {isFetchingDetalheCampanha
                            ? "..."
                            : campanhaData?.indicadores?.mediaLigacoesDiarias.toString() ===
                              "0"
                            ? "XX"
                            : campanhaData?.indicadores?.mediaLigacoesDiarias.toString() ||
                              "XX"}
                        </S.InfoNumber>{" "}
                        ligações diárias (média)
                      </S.InfoText>
                    </S.InfoItem>

                    <S.InfoItem>
                      <MdEventNote size={24} />
                      <S.InfoText>
                        <S.InfoNumber>
                          {isFetchingDetalheCampanha
                            ? "..."
                            : campanhaData?.indicadores?.diasCorridos.toString() ===
                              "0"
                            ? "XX"
                            : campanhaData?.indicadores?.diasCorridos.toString() ||
                              "XX"}
                        </S.InfoNumber>{" "}
                        dias corridos de campanha
                      </S.InfoText>
                    </S.InfoItem>
                  </S.DataInfo>
                </S.ContainerData>
              </div>
            </S.ColContainer>
          </S.FlexContainer>
        </S.ContainerLeft>
        <S.ContainerRight style={{ width: "40%", minWidth: "350px" }}>
          <S.Title2>Direcionamento de campanha</S.Title2>
          <S.FlexContainer>
            <CorretoresSelector
              cargos={cargos}
              corretoresSelecionados={corretoresSelecionados}
              setCorretoresSelecionados={setCorretoresSelecionados}
              corretoresData={campanhaData?.idsCorretoresSistemaOrigem ?? []}
              idEquipe={campanhaData?.idEquipe ?? ""}
              nomeEquipe={campanhaData?.nomeEquipe ?? ""}
            />
          </S.FlexContainer>
        </S.ContainerRight>
      </S.Content>
      <S.Footer>
        {cargos.isGerenteVendas && (
          <>
            <S.BackButton onClick={() => history.push("/campanhas-criadas")}>
              ← Voltar
            </S.BackButton>
            <S.NewCampaignButton onClick={handleSalvarCampanha}>
              {isFetchingDetalheCampanha ? (
                "Carregando..."
              ) : (
                <>
                  {isPendingEditarCampanha ? (
                    "Salvando..."
                  ) : (
                    <>
                      <FaSave /> Salvar Campanha
                    </>
                  )}
                </>
              )}
            </S.NewCampaignButton>
          </>
        )}
        {cargos.isSuperintendente && (
          <S.BackButton onClick={() => history.push("/campanhas-criadas")}>
            ← Voltar para lista de campanhas
          </S.BackButton>
        )}
      </S.Footer>
      {/* <S.StyledSwipeableDrawer
        anchor="right"
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        onOpen={() => setIsFilterDrawerOpen(true)}
      >
        <FilterDrawer
          onCloseModal={() => setIsFilterDrawerOpen(false)}
          onApplyFilters={(filters) => {
            console.log("Filtros aplicados:", filters);
            // Aqui você implementa a lógica dos filtros
          }}
          onClearFilters={() => {
            console.log("Filtros limpos");
            // Aqui você implementa a lógica para limpar
          }}
        />
      </S.StyledSwipeableDrawer> */}
    </S.Container>
  );
};

export default DetailCampanha;
